module.exports = __webpack_public_path__ + "static/media/Remove-Cuvette.ad6d8119.svg";